export const TRANSLATIONS_ZH_CN = {
  nav: {
    candidates: '候选人',
    reports: '汇报'
  }
};
